import { render, staticRenderFns } from "./ProjectInfos.vue?vue&type=template&id=109e1df8&"
import script from "./ProjectInfos.vue?vue&type=script&lang=js&"
export * from "./ProjectInfos.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfos.vue?vue&type=style&index=0&id=109e1df8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports